import React, { useState } from 'react';
import { FaGithub, FaExternalLinkAlt, FaCode, FaRocket } from 'react-icons/fa';
import { projectsData } from '../data/projectsData';
import './Projects.css';

const Projects = () => {
  const [filter, setFilter] = useState('all');

  const filteredProjects = filter === 'all' 
    ? projectsData 
    : projectsData.filter(project => project.category === filter);

  const categories = ['all', 'demo', 'tutorial', 'enterprise'];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <h2 className="section-title">Projects & Demos</h2>
        <p className="section-subtitle">
          Interactive demos and notebooks showcasing AI capabilities
        </p>

        <div className="filter-buttons">
          {categories.map(category => (
            <button
              key={category}
              className={`filter-btn ${filter === category ? 'active' : ''}`}
              onClick={() => setFilter(category)}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
        </div>

        <div className="projects-grid grid grid-3">
          {filteredProjects.map((project, index) => (
            <div key={index} className="project-card card">
              <div className="project-header">
                <div className="project-icon">
                  {project.icon || <FaCode />}
                </div>
                <div className="project-category-badge">
                  {project.category}
                </div>
              </div>

              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>

              <div className="project-tech">
                {project.technologies.map((tech, i) => (
                  <span key={i} className="tech-tag">{tech}</span>
                ))}
              </div>

              <div className="project-links">
                {project.github && (
                  <a 
                    href={project.github} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="project-link"
                    aria-label="View on GitHub"
                  >
                    <FaGithub /> Code
                  </a>
                )}
                {project.demo && (
                  <a 
                    href={project.demo} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="project-link"
                    aria-label="View demo"
                  >
                    <FaExternalLinkAlt /> Demo
                  </a>
                )}
                {project.article && (
                  <a 
                    href={project.article} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="project-link"
                    aria-label="Read article"
                  >
                    <FaRocket /> Article
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;

